import { DOCUMENT } from '@angular/common';
import { inject } from '@angular/core';

import { MpsUserService } from '../../mps/services/mps-user.service';

export function initNavVisibility(): () => void {
  const userService = inject(MpsUserService);
  const document = inject(DOCUMENT);

  return () => {
    userService.getUserSubject().subscribe((user) => {
      // A missing IGG is NOT the signal: a named user created from the back-office without one
      // is a real user and keeps the menu.
      if (user && user.is_station_account) {
        document.body.classList.add('no-nav-user');
      } else {
        document.body.classList.remove('no-nav-user');
      }
    });
  };
}
